/* eslint camelcase: 0 */
import { ChatSeed } from '@/infrastructure/network/OpenAi/schema'
import { IChatProps } from '@/entities/ChatGPT/Chat'

export const toChatSeed = (props: IChatProps): ChatSeed => {
  const { messages, model, stream } = props
  return {
    messages,
    model: model!,
    stream
  }
}
